import axiosInstance from '@/shared/api/axios';
import type { ParcelCharge } from '@/shared/types/api/charges';

export const apiParcelChargesGet = async (parcelId: string): Promise<ParcelCharge[]> => {
  const { data } = await axiosInstance.get<ParcelCharge[]>(`/parcels/${parcelId}/charges`);
  return data;
};
